import { DefinitionDescription, DefinitionTerm } from "@/components/ui/definition-list.tsx";
import useConfigCode from "@/features/sub-families/hooks/use-config-code.ts";
import useCurrentMountingKit from "@/services/product/hooks/use-current-mounting-kit.ts";
import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import { LABEL_DELIMITER } from "@/resources/constants.ts";
import { type Nullable, SmartNumberDescriptor } from "@/types";
import { isText } from "@/utils/types.ts";

export default function MountingKitDetails() {
    const t = useTranslations();
    const currentProduct = useCurrentProduct();
    const mountingKit = useCurrentMountingKit();

    const { getConfigCodeByDescriptor, getEmptyConfigCodeByDescriptor } = useConfigCode();

    if (!currentProduct) return null;

    const emptyConfigCode = getEmptyConfigCodeByDescriptor(SmartNumberDescriptor.MountingKit);
    const configCode = getConfigCodeByDescriptor(SmartNumberDescriptor.MountingKit);

    let label: Nullable<string>;
    if (emptyConfigCode === configCode) {
        label = t("no_mounting_kit");
    } else {
        label = [mountingKit?.sku, mountingKit?.description].filter(isText).join(LABEL_DELIMITER);
    }

    if (label === null) return null;

    return (
        <>
            <DefinitionTerm>{t("mounting_kit")}</DefinitionTerm>
            <DefinitionDescription>{label}</DefinitionDescription>
        </>
    );
}
